import script from "./MaterialStatusTab.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialStatusTab.vue?vue&type=script&setup=true&lang=js"

import "./MaterialStatusTab.vue?vue&type=style&index=0&id=7cda4efc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cda4efc"]])

export default __exports__